if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.spinner = this.querySelector(".spinner");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        this.showSpinner();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            this.cartNotification.renderContents(response);
            this.updateCartItems(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");

            this.hideSpinner();

            trackCustom("CartUpdate", "Shopify", "");
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                items: [
                  {
                    item_id: productData.id,
                    item_name: productData.title,
                    item_brand: productData.vendor,
                    item_category: productData.collection,
                    item_variant: productData.variant,
                    currency: productData.currency,
                    price: productData.price,
                  },
                ],
              },
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      updateCartItems(data) {
        const item = cartItems.find(item => item.item_variant === data.sku);

        if (item) {
          item.quantity = data.quantity.toString();
        } else {
          cartItems.push({
            'item_id': data.id.toString(),
            'item_name': data.product_title,
            'item_brand': data.vendor,
            'item_category': productData.collection,
            'item_variant': data.sku,
            'currency': shopCurrency,
            'price': (data.price * 0.01).toString(),
            'quantity': data.quantity.toString()
          });
        }
      }

      showSpinner() {
        this.spinner?.classList?.remove("hidden");
      }

      hideSpinner() {
        this.spinner?.classList?.add("hidden");
      }
    }
  );
}
